/* c8 ignore start */
import { SAT_SERVICE } from "@/utils/services";

export const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "report_manager",
      name: "msp-report_manager",
      component: () =>
        import(
          "@/modules/ReportManager/views/msp/report-manager/report-manager.index.vue"
        ),
      meta: {
        solutionId: SAT_SERVICE,
      },
      children: [],
    },
  ],
};

export default {};
/* c8 ignore end */
